<template>
  <div>
    <el-form-item :required="required">
      <template #label>{{ codeEnum.code }}</template>
      <el-row :gutter="gutter">
        <el-col :span="span1" class="col_positon">
          <el-form-item ref="elFormItem" :prop="prop" :rules="rules">
            <el-input
              v-model="localInputVal"
              v-input.num_alp
              class="left_input"
              maxlength="3"
              :disabled="showList || localDisabled"
              :class="[showList ? 'multiple' : '']"
              @input="handleLocalInputVal"
              @blur="handleBlur"
            />
            <template #error="{ error }">
              <el-tooltip
                class="item"
                effect="dark"
                :content="error"
                placement="bottom"
              >
                <div class="el-form-item__error">{{ error }}</div>
              </el-tooltip>
            </template>
            <div
              v-if="!localDisabled"
              class="more_box flex_center flex_center_align"
              @click="selectDep"
            >
              <svg-icon icon-class="select" />
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="span2">
          <el-input
            v-model="localInputName"
            class="right_input"
            :class="[showList ? 'multiple' : '']"
            disabled
          />
          <el-popover v-show="showList" placement="bottom" trigger="click">
            <el-table :data="list" border stripe>
              <el-table-column
                width="105"
                header-align="center"
                align="center"
                property="itmdtlcd"
                label="商品明細ＣＤ"
              />
              <el-table-column
                width="180"
                property="itmdtlnm"
                header-align="center"
                align="center"
                label="商品明細名"
              />
            </el-table>
            <div
              slot="reference"
              class="more_box flex_center flex_center_align more_change_box"
            >
              <div class="inner_box flex_center flex_center_align">
                <svg-icon :icon-class="'sel'" />
              </div>
            </div>
          </el-popover>
        </el-col>
      </el-row>
    </el-form-item>
    <MitmdtlpDialogNew
      ref="dialog"
      :visible.sync="dialogVisible"
      :title="dialogTitle"
      :code-field="codeField"
      :name-field="nameField"
      :goodslists="goodslists"
      :multi-select="multiSelect"
      @get-selection="getSelection"
    />
  </div>
</template>

<script>
  import mixComponent from '@/utils/mixComponent'
  import { queryItemDetail } from '@/api/rc/queryItemDetailGroupList'
  export default {
    // 商品明細
    name: 'MitmdtlpNew',
    componentName: 'VabMitmdtlpNew',
    mixins: [mixComponent],
    props: {
      goodslists: {
        type: Array,
        default: () => [],
      },
      codeEnum: {
        type: Object,
        default: () => {
          return {
            code: '商品明細',
            value: '商品明細CD',
            text: '商品明細選択',
            table: '商品明細マスタ',
          }
        },
      },
    },
    // watch: {
    //   goodslists: function (newValue, oldValue) {
    //     if (!_.isEqual(newValue, oldValue)) {
    //       this.reset()
    //     }
    //   },
    // },
    created() {
      this.codeField = 'itmdtlcd'
      this.nameField = 'itmdtlnm'
    },
    methods: {
      initParams() {
        let dialog = this.$refs['dialog']
        let itmcdList = this.$baseLodash.map(this.goodslists, 'itmcd')
        let queryForm = dialog.queryForm
        queryForm.itmdtlcd = null
        queryForm.itmdtlnmk = null
        queryForm.itmcdList = itmcdList
      },
      async getOne(val) {
        if (val) {
          const { list } = await queryItemDetail({ itmdtlcd: val })
          return list[0]
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import '@/vab/styles/component.scss';
</style>
